import { render, staticRenderFns } from "./BannerAdvertisingSlideContent.vue?vue&type=template&id=d13d22ce&scoped=true&"
import script from "./BannerAdvertisingSlideContent.vue?vue&type=script&lang=js&"
export * from "./BannerAdvertisingSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./BannerAdvertisingSlideContent.vue?vue&type=style&index=0&id=d13d22ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d22ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
